<div class="contact-us-container">
  <div class="contact-us-container-wrapper w-100">
    <div class="heading">
      {{translationLabels['contact-us.heading']}}
    </div>
    <div class="contact-info">
      <div class="customer-service">
        <space-icon icon="callinprogress" fill="#FFAA00"></space-icon>
        <div class="contact-header">{{translationLabels['contact-us.customer-service']}}</div>
        <div class="service-info font-size-14">{{translationLabels['contact-us.constomer-service-desc']}}
        </div>
        <div class="font-size-14">{{translationLabels['contact-us.phone']}}</div>
        <div class="phone-number font-size-14">{{translationLabels['contact-us.phone-number']}}</div>
      </div>
      <div class="general-inquiries">
        <space-icon icon="callinprogress" fill="#FFAA00"></space-icon>
        <div class="contact-header">{{translationLabels['contact-us.general-inquiry']}}</div>
        <div class="service-info font-size-14">{{translationLabels['contact-us.constomer-service-desc']}}</div>
        <div class="font-size-14">{{translationLabels['contact-us.phone']}}</div>
        <div class="phone-number font-size-14">{{translationLabels['contact-us.phone-number']}}</div>
      </div>
    </div>
    <div class="contact-info">
      <div class="customer-service address-css">
        <space-icon class="space-icon" icon="onmap" fill="#FFAA00"></space-icon>
        <div class="contact-header">{{translationLabels['contact-us.correspondence']}}</div>
        <div class="text-wrapper">
          <div class="service-info font-size-14">{{translationLabels['contact-us.address-desc']}}
          </div>
          <div class="address-details" [innerHTML]="translationLabels['contact-us.address-details']"> </div>
        </div>
      </div>
    </div>
  </div>
</div>